<template>
  <router-view></router-view>
  <Preloader :showModal="showM"></Preloader>
</template>

<script>
/* eslint-disable */

import { Hub, Logger } from "aws-amplify";
import { Auth } from "@aws-amplify/auth";
import {
  computed,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
} from "@vue/runtime-core";
import store from "@/store";
import router from "@/router";
import { useRoute } from "vue-router";
import {
  getAccountsByEmail,
  getAccountsMt5ByEmail,
  getApplicationsByEmail,
  getPreferenceByEmail,
  getUserByEmail,
  getPreferencesSite,
  initializePreferences,
  registerUserBasicStep,
  application_form,
  accountslv4,
  accountslv5,
  accountsDm4,
  accountsDm5,
  translateText
} from "@/plugins/authUtils";
import axios from "axios";
import Preloader from "@/components/Preloader";
import { i18n } from "@/plugins/i18n";
import { performSignInFlow, performSignUpFlow } from "./plugins/flows";

/* comment  */
const logger = new Logger("main");

export default {
  name: "app",
  components: {
    Preloader,

  },
  data() {
    return {
      authUser: null,
    };
  },
  setup() {

    const region = ref(process.env.VUE_APP_CABINET_ORIGIN);
    console.log("App setup ... ");
    const route = useRoute();
    let showM = ref(false);
    let userObj = ref(null);
    let msgs = ref([]);
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;
    console.log(emitter);
    //  DETECTA CAMBIOS DE AUTH
    console.log("Setting Amplify listener ");
    Hub.listen("auth", (data) => {
      if (data.payload.event === "tokenRefresh_failure") {
        console.error("critical: " + data.payload.event);
        return;
      }

      checkAuthUser();
      store.commit("setLoginEvent", data.payload.event);

      let user;
      let email;
      let signedIn = false;
      switch (data.payload.event) {
        case "signIn":
          showM.value = false;
          if (data.payload.data.hasOwnProperty("attributes")) {
            emitter.emit("authStateUpdated", {
              email: data.payload.data.attributes.email,
              state: "LOGGED_IN",
            });
          }
          break;
        case "signUp":
          showM.value = false;
          email = data.payload.data.user.username;
          emitter.emit("authStateUpdated", {
            email: email,
            state: "REGISTERED",
          });
          break;
        case "signOut":
          showM.value = false;
          store.commit("setLoginEvent", "LOGGED_OUT");
          localStorage.removeItem("storedAccounts");
          localStorage.removeItem("typeAccount");
          localStorage.removeItem("activeAccount");
          emitter.emit("authStateUpdated", {
            state: "LOGGED_OUT",
          });
          break;
        case "signIn_failure":
          // console.log('user sign in failed')
          break;
        case "configured":
          // console.log('the Auth module is configured')
          break;
        case "forgotPasswordSubmit":
          // console.log('submitted a forgotten password code')
          break;
        case "tokenRefresh_failure":
          // console.log('token refresh failure!')
          break;
        default:
          // console.log('unknown event: ' + data.payload.event)
          break;
      }
    });
    // Esta función aplica las reglas del negocio cuando el usuario está autenticado
    const doAuthenticatedUser = async (email) => {
      console.log("doAuthenticatedUser ...  applying bussines rules");
      showM.value = true;

      console.log("Getting Authenticate user data ...");
      let userInfo = await getUserByEmail(email).catch((error) => {
        logger.error(error);
        console.log(error);
      });

      if (!userInfo) {
        console.log("registerUserBasicStep ... TODO - What is it ?");
        userInfo = await registerUserBasicStep(email);
      }

      console.log("Get Accounts ... Just if the user is Active");
      if (userInfo) {
        store.commit("setUser", userInfo);
        emitter.emit("userUpdated");

        if (userInfo.registerStatus === "ACTIVE") {
          let accounts = await getAccountsByEmail(email, store).catch(
            (error) => {
              logger.error(error);
              console.log(error);
            }
          );
        } else {
          console.log("User is not Active ... " + userInfo.registerStatus);
        }

        // GET busca las preferencias
        console.log("Buscando Preferencias ...");
        let preferences = await getPreferenceByEmail(email).catch((error) => {
          logger.error(error);
        });

        // Language change implementation
        let langHtmlElement = document.documentElement;
        let pageLang = localStorage.getItem("language");
        langHtmlElement.setAttribute("lang", pageLang);
        if ("ar" === pageLang) {
          langHtmlElement.setAttribute("dir", "rtl");
        } else {
          langHtmlElement.setAttribute("dir", "ltr");
        }

        // GET formulario Application procces
        console.log("Cargando Formulario de App Process ...");
        if (userInfo.registerStatus === "AT_DETAILS") {
          let application_form_structure = await application_form().catch(
            (error) => {
              logger.error(error);
            }
          );

          // Guardando Formulario de Apliación
          if (
            application_form_structure.data !== undefined &&
            application_form_structure.data !== null
          ) {
            localStorage.setItem(
              "form_procces",
              JSON.stringify(application_form_structure.data)
            );
            console.log("Guardando el Formulario de Aplilcación ...");
          }
        }
        // GET cuentas mt4 live
        console.log("Cargando cuentas mt4 live ...");
        console.log(userInfo.registerStatus);
        if (userInfo.registerStatus === "ACTIVE") {
          let call_accountslv4 = await accountslv4().catch((error) => {
            logger.error(error);
          });

          // Guardando cuentas mt4 live in localstorage
          if (call_accountslv4 !== "undefined" || call_accountslv4 !== null) {
            localStorage.setItem(
              "Accountslv4",
              JSON.stringify(call_accountslv4)
            );
          } else {
            localStorage.setItem("Accountslv4", "error");
          }
        }

        // GET cuentas mt5 live
        console.log("Cargando cuentas mt5 live ...");
        if (userInfo.registerStatus === "ACTIVE") {
          let call_accountslv5 = await accountslv5().catch((error) => {
            logger.error(error);
          });

          // Guardando cuentas mt5 live in localstorage
          if (call_accountslv5 !== undefined || call_accountslv5 !== null) {
            localStorage.setItem(
              "Accountslv5",
              JSON.stringify(call_accountslv5)
            );
          } else {
            localStorage.setItem("Accountslv5", "error");
          }
        }

        // GET cuentas mt4 demo
        console.log("Cargando cuentas mt4 demo ...");

        let call_accountsDm4 = await accountsDm4().catch((error) => {
          logger.error(error);
        });
        // Guardando cuentas mt4 demo in localstorage
        console.log(call_accountsDm4);
        if (call_accountsDm4 !== "undefined" || call_accountsDm4 !== null) {
          localStorage.setItem("Accountsdm4", JSON.stringify(call_accountsDm4));
        } else {
          localStorage.setItem("Accountsdm4", "error");
        }

        // GET cuentas mt5 demo
        console.log("Cargando cuentas mt5 demo ...");


        let call_accountsDm5 = await accountsDm5().catch((error) => {
          logger.error(error);
        });
        // Guardando cuentas mt5 demo in localstorage
        if (call_accountsDm5 !== undefined || call_accountsDm5 !== null) {
          localStorage.setItem(
            "Accountsdm5",
            JSON.stringify(call_accountsDm5)
          );
        } else {
          localStorage.setItem("Accountsdm5", "error");
        }


        //POST crea y guarda preferencias
        if (!preferences) {
          console.log("Inicializando preferencias ...");
          preferences = await initializePreferences(email).catch((error) => {
            logger.error(error);
          });
        }

        // Qué hace esto?
        console.log("Origin ? ...");
        let htmlElement = document.documentElement;
        htmlElement.setAttribute(
          "cabinet-origin",
          process.env.VUE_APP_CABINET_ORIGIN
        );

        if (preferences) {
          console.log("? ...");
          let htmlElement = document.documentElement; // Esta línea está repetida

          switch (preferences.data.theme) {
            case "DARK":
              htmlElement.setAttribute("theme", "dark");
              break;
            case "LIGHT":
              htmlElement.setAttribute("theme", "light");
              break;
          }

          if (localStorage.getItem("language") === "ar") {
            htmlElement.setAttribute("dir", "rtl");
          } else {
            htmlElement.setAttribute("dir", "ltr");
          }

          console.log("Guardamos preferencias ...");
          store.commit("setPreferences", preferences);
          emitter.emit("preferencesUpdated");
        } else {
          logger.error("unable to retrieve user preferences");
        }

        // ??
        if (userInfo.applicationID) {
          console.log("?? ...");
          let application = "Application Done";
          if (userInfo.registerStatus != "ACTIVE") {
            application = await getApplicationsByEmail(
              email,
              userInfo.applicationID
            ).catch((error) => {
              logger.error(error);
            });
          }

          if (!application) {
            application = await createAndAssignAnApplicationProcess(
              userInfo,
              "INDIVIDUAL"
            ).catch((error) => {
              logger.error(error);
            });
          }
          if (application) {
            store.commit("setApplication", application);

            emitter.emit("applicationUpdated");

          }
        }
        emitter.emit("userSet");
        let routerChanger = window.location.pathname
          .replace(/\/$/, "")
          .split("/")
          .pop();
        let statusUser = store.state.user.registerStatus;

        // ???
        if (statusUser !== undefined && statusUser !== null) {
          console.log("??? ...");

          switch (statusUser) {
            case "AT_PASSWORD":
              let accountRegis =
                localStorage.getItem("typeAccount") === null
                  ? "live-account"
                  : localStorage.getItem("typeAccount");
              router.replace("/register/2/" + accountRegis).catch((error) => {
                logger.error(error);
              });
              break;
            case "INACTIVE":
              await Auth.signOut();
              break;
            default:
              // comment for no longer MFA
              //if (userObj.preferredMFA == "NOMFA") {
              //routerChanger = "/cabinet/console/platforms";
              //}
              switch (routerChanger) {
                case "login":
                  if (statusUser == "ACTIVE") {
                    routerChanger = "/cabinet/console/accounts";
                  } else if (statusUser == "PENDING_VALIDATION") {
                    routerChanger = "/cabinet/console/platforms";
                  } else {
                    routerChanger = "/cabinet/console/platforms";
                  }
                  break;
                case "live-account":
                  routerChanger = "/cabinet/console/platforms";
                  break;
                case "demo-account":
                  routerChanger = "/cabinet/console/create_new_demo_account";
                  break;
              }

              document.title =
                "Client Cabinet | " +
                process.env.VUE_APP_CABINET_V2_WEBSITE_NAME;
              router.replace(routerChanger).catch((error) => {
                logger.error(error);
              });
              break;
          }

          localStorage.setItem(
            "activeAccount",
            store.state.user.registerStatus
          );
        }

        // Cargar Métodos de Pago (Site Preferences)
        console.log("Cargar Métodos de Pago (Site Preferences) ... ");
        let paymentMethods = await getPreferencesSite(email).catch((error) => {
          logger.error(error);
        });

        // Salvar métodos de pago
        if (paymentMethods !== undefined && paymentMethods !== null) {
          console.log("Salvar Métodos de Pago (Site Preferences) ... TODO");
          // result.data.data.platforms_payments
          localStorage.setItem(
            "DepositMethods",
            JSON.stringify(paymentMethods.data.platforms_payments)
          );
        }

        showM.value = false;

        //  TODO: only if not subscribed
        // subscribeToUserChanges(userInfo.id)
      } else {
        throw "CRITICAL ERROR: Contact tech team!";
      }
    };

    //  APLICA REGLAS DE NEGOCIO SEGUN AUTH
    const checkAuthUser = () => {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          store.commit(
            "setToken",
            user.signInUserSession.idToken.getJwtToken()
          );
          doAuthenticatedUser(user.attributes.email);
        })
        .catch((err) => {
          console.log(
            "WARNING: error during checkAuthUser flow or user logged out; details follow..."
          );
          console.log(err);
          let langHtmlElement = document.documentElement;
          let pageLang = localStorage.getItem("language");

          if (pageLang) {
            langHtmlElement.setAttribute("lang", pageLang);
            if ("ar" === pageLang) {
              langHtmlElement.setAttribute("dir", "rtl");
            } else {
              langHtmlElement.setAttribute("dir", "ltr");
            }
          } else {
            // if ("mena" === region.value) {
            //   langHtmlElement.setAttribute("lang", "en");
            //   langHtmlElement.setAttribute("dir", "ltr");
            // } else {
            //   langHtmlElement.setAttribute("lang", "ar");
            //   langHtmlElement.setAttribute("dir", "rtl");
            // }
            langHtmlElement.setAttribute("lang", "en");
            langHtmlElement.setAttribute("dir", "ltr");
          }
          console.log(err);
          store.commit("clearUser");
        });
    };

    const signOut = async () => {
      await Auth.signOut();
      emitter.emit("successfulRequest");
    };

    const federatedSignIn = async (params) => {
      showM.value = true;
      Auth.federatedSignIn({ provider: params.provider });
    };
    const traslateLabel = (msg_translate) => {
      const translationMap = {
        "Incorrect username or password.": "loginPage.userError",
        "User does not exist.": "loginPage.userErrorTwo"
      };
      return translateText(msg_translate, translationMap);
    }

    const signIn = async (email, password) => {
      showM.value = true;
      let newPassword = password;
      let regInfo = store.state.userRegistration;

      Auth.signIn(email, password)
        .then((user) => {
          userObj = user;
          switch (user.challengeName) {
            case "NEW_PASSWORD_REQUIRED":
              showM.value = false;
              Auth.completeNewPassword(user, newPassword)
                .then((user) => {
                  // at this time the user is logged in if no MFA required
                })
                .catch((e) => {
                  emitter.emit("showDialog", e.message);
                });
              break;
            case "SOFTWARE_TOKEN_MFA":
              showM.value = false;
              emitter.emit("showTOTPDialog", i18n.global.t("register.mfaCode"));
              break;
            case "SMS_MFA":
              showM.value = false;
              emitter.emit("showTOTPDialog", i18n.global.t("register.mfaCode"));
              break;
            default:
              showM.value = false;
              let jwt = store.state.token;
              performSignInFlow(jwt)
                .then((result) => {
                  if (result) {
                    let regInfo = store.state.userRegistration;
                    if (typeof regInfo !== "undefined" && regInfo !== null) {
                      performSignUpFlow(regInfo, jwt)
                        .then((result) => {
                          store.commit("setUser", result.user);
                          router
                            .replace("/cabinet/console/accounts")
                            // .replace("/cabinet/console/aplicationprocess")
                            .catch((err) => { });
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    }
                  } else {
                    store.commit("setUser", result);
                  }
                })
                .catch((error) => {
                  showM.value = false;
                  console.error(error);
                });

              break;
          }
          emitter.emit("successfulRequest");
        })
        .catch((e) => {
          showM.value = false;
          if (e.message === "User is not confirmed.") {
            //OJO! PREGUNTAR A ERWIN SI EL CODIGO COMENTADO SE DEBE ELIMINAR
            // dialogMessage.value = 'Please enter the activation code'
            // showCodeDialog.value = true
            emitter.emit("requestNewCode", {
              email: email,
            });
            // if (store.state.loginFlow === 'LOGIN') {
            //   emitter.emit('showCodeDialogAtLogin', "Please enter the activation code")
            // } else {
            //   emitter.emit('showCodeDialog', "Please enter the activation code")
            // }
            emitter.emit("failedRequest");
          } else {
            // dialogMessage.value = e.message
            // showDialog.value = true

            emitter.emit("showDialog", traslateLabel(e.message));
            //emitter.emit("failedRequest");
            console.log(e.message);
          }
          // loginBox.value.release()
        });
    };

    const signUp = async (email, password, disclaimer) => {
      let username = email;
      showM.value = true;
      try {
        const { user } = await Auth.signUp({
          username,
          password,
          disclaimer,
          attributes: { email },
        });
        emitter.emit("successfulRequest");
      } catch (error) {
        showM.value = false;
        emitter.emit("showDialog", error.message);
        if (error.code === "UsernameExistsException") {
          setTimeout(() => {
            router.replace("/login");
          }, 5000);
        }
        emitter.emit("failedRequest");
      }
    };

    const requestNewCode = async (email) => {
      try {
        Auth.resendSignUp(email)
          .then((_) => {
            if (store.state.loginFlow === "LOGIN") {
              emitter.emit(
                "showCodeDialogAtLogin",
                i18n.global.t("register.newCode")
              );
            } else {
              emitter.emit(
                "showCodeDialog",
                i18n.global.t("register.newCode")
              );
            }
            emitter.emit("successfulRequest");
          })
          .catch((error) => {
            if (error.code === "LimitExceededException") {
              if (store.state.loginFlow === "LOGIN") {
                emitter.emit("showDialog", i18n.global.t("register.tryEgain"));
              } else {
                emitter.emit("showDialog", i18n.global.t("register.tryEgain"));
              }
            } else {
              emitter.emit("showCodeDialogErrorMessage", error.message);
            }
            emitter.emit("failedRequest");
          });
      } catch (error) {
        emitter.emit("showDialog", error.message);
        emitter.emit("failedRequest");
      }
    };

    const requestConfirmSignUp = async (email, newCode) => {
      try {
        Auth.confirmSignUp(email, newCode)
          .then(() => {
            emitter.emit("showDialog", i18n.global.t("register.registering"));
            emitter.emit("closeAllLoginDialogs");
            emitter.emit("closeAllRegisterDialogs");
            emitter.emit("successfulRequest");

            router
              .replace("/register/2/" + localStorage.getItem("typeAccount"))
              .catch((error) => {
                console.error(error);
              });
          })
          .catch((error) => {
            emitter.emit("showCodeDialogErrorMessageAtLogin", error.message);
            emitter.emit("failedRequest");
          });
      } catch (error) {
        emitter.emit("showDialog", error.message);
        emitter.emit("failedRequest");
      }
    };

    const requestConfirmSignUpAndLogin = async (email, newCode, pass) => {
      showM.value = true;
      try {
        Auth.confirmSignUp(email, newCode)
          .then(() => {
            emitter.emit("closeAllLoginDialogs");
            emitter.emit("closeAllRegisterDialogs");
            showM.value = false;
            return Auth.signIn(email, pass);
          })
          .then(() => {
            showM.value = false;
            emitter.emit("successfulRequest");
          })
          .catch((error) => {
            showM.value = false;
            emitter.emit("showCodeDialogErrorMessage", error.message);
            emitter.emit("failedRequest");
          });
      } catch (error) {
        emitter.emit("showDialog", error.message);
        emitter.emit("failedRequest");
      }
    };

    const requestForgotPassword = async (email) => {
      Auth.forgotPassword(email)
        .then((data) => {
          showM.value = false;
          emitter.emit("showForgotDialog", i18n.global.t("register.instructions"));
          emitter.emit("successfulRequest");
        })
        .catch((error) => {
          emitter.emit("showDialog", error.message);
          emitter.emit("failedRequest");
        });
    };

    const requestTOTPLogin = async (totpCode) => {
      Auth.confirmSignIn(
        userObj,
        totpCode.value.toString(),
        userObj.challengeName
      )
        .then((user) => {
          showM.value = false;
          emitter.emit("successfulRequest");
        })
        .catch((e) => {
          emitter.emit("showDialog", e.message);
          emitter.emit("failedRequest");
        });
    };

    const createAndAssignAnApplicationProcess = (user, accountType) =>
      new Promise((resolve, reject) => {
        let applicationProcess;
        showM.value = true;
        let _url =
          process.env.VUE_APP_CABINET_V2_API_HOST_DEMO + "/demoaccount/create";
        let _headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + store.state.token,
          'X-Api-Key': process.env.VUE_APP_X_API_KEY
        };
        let _data = {
          applicationType: accountType,
          disclaimer: true,
        };

        axios({ method: "POST", url: _url, data: _data, headers: _headers })
          .then((result) => {
            let item = result.data.updateUser;
            if (item != null) {
              resolve(applicationProcess);
              showM.false;
            } else {
              showM.false;
              logger.error("ERROR: unable to update the user record");
              reject("ERROR: unable to update the user record");
            }
          })
          .catch((error) => {
            logger.error(error);
            reject(error);
          });
      });

    onMounted(() => {
      //  FORZAR REFRESH
      emitter.on("requestUserRefresh", () => {
        checkAuthUser();
      });

      //  VALIDAR USUARIO (FLUJO PARA REGISTRO)
      emitter.on("doAuthenticatedUser", (user) => {
        doAuthenticatedUser(user);
      });

      //  reload the application
      emitter.on("requestApplicationRefresh", () => {
        let application = store.state.application;
        showM.value = true;
        if (application !== null) {
          getApplicationsByEmail(application.email, application.id)
            .then((application) => {
              // console.log('--- GET APPLICATION ---')
              // console.log(application)

              store.commit("setApplication", application);
              emitter.emit("applicationUpdated");
              showM.value = false;
            })
            .catch((error) => {
              logger.error(error);
            });
        }
      });

      emitter.on("requestSignIn", (params) => {
        signIn(params.email, params.password);
      });

      emitter.on("requestSignUp", (params) => {
        signUp(params.email, params.password, params.disclaimer);
      });

      emitter.on("requestSignOut", () => {
        signOut();
      });

      emitter.on("requestRegister", (params) => {
        signUp(params.email, params.password);
      });

      emitter.on("requestNewCode", (params) => {
        requestNewCode(params.email);
      });

      emitter.on("requestTOTPLogin", (params) => {
        requestTOTPLogin(params.totpCode);
      });

      emitter.on("requestConfirmSignUp", (params) => {
        requestConfirmSignUp(params.email, params.newCode);
      });

      emitter.on("requestConfirmSignUpAndLogin", (params) => {
        requestConfirmSignUpAndLogin(
          params.email,
          params.newCode,
          params.password
        );
      });

      emitter.on("requestForgotPassword", (params) => {
        requestForgotPassword(params.email);
      });

      emitter.on("federatedSignIn", (params) => {
        federatedSignIn(params);
      });

      checkAuthUser();
    });

    onUnmounted(() => {
      emitter.off("requestApplicationRefresh");
      emitter.off("requestUserRefresh");
      emitter.off("requestSignIn");
      emitter.off("requestSignUp");
      emitter.off("requestSignOut");
      emitter.off("requestRegister");
      emitter.off("requestNewCode");
      emitter.off("requestConfirmSignUp");
      emitter.off("requestConfirmSignUpAndLogin");
      emitter.off("requestForgotPassword");
      emitter.off("requestTOTPLogin");
    });

    return {
      checkAuthUser,
      getUserByEmail,
      getPreferencesSite,
      registerUserBasicStep,
      showM,
      msgs,
      region,
    };
  },
};
</script>

<style lang="scss">
@import "assets/css/style";
</style>
